import Vue from 'vue';
import VueRouter from 'vue-router';
import Survey from '@/components/survey/Survey.vue';
import Container from '@/components/Container.vue';
import SarahCounter from '@/components/SarahCounter.vue';
import Impressum from '@/components/Impressum.vue';
import Datenschutz from '@/components/Datenschutz.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Container,
  },
  {
    path: '/survey',
    name: 'survey',
    component: Survey,
  },
  {
    path: '/counter',
    name: 'counter',
    component: SarahCounter
    ,
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: Impressum
    ,
  },
  {
    path: '/datenschutz',
    name: 'datenschutz',
    component: Datenschutz
    ,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return undefined;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
